'use client';

import '@maptiler/sdk/dist/maptiler-sdk.css';

import { type Map } from '@maptiler/sdk';
import * as maptilersdk from '@maptiler/sdk';
import { type LngLatLike } from 'maplibre-gl';
import {
  useEffect,
  useRef,
} from 'react';
import { useIsMounted } from 'usehooks-ts';

import mapStyle from '@/features/listing/components/listings-map/map/map-style';

import styles from './listing-detail-map.module.scss';

interface ListingDetailMapProps {
  coordinates: LngLatLike;
}

export default function ListingDetailMap(props: ListingDetailMapProps) {
  const { coordinates } = props;

  const isMounted = useIsMounted();

  const map = useRef<Map | null>(null);
  const mapContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (map.current) return;

    map.current = new maptilersdk.Map({
      center: coordinates,
      // @ts-expect-error - wrong types in lib
      container: mapContainer.current,
      geolocateControl: false,
      interactive: false,
      navigationControl: false,
      // @ts-expect-error - wrong types in lib
      style: mapStyle,
      target: mapContainer.current,
      zoom: 14,
    });

    map.current.on('load', () => {
      if (map.current) {
        map.current.addSource('planet', {
          tiles: ['https://map.roomster.com/data/v3/{z}/{x}/{y}.pbf?key=oxQ5YeTFJ13jkTv9eIN9pB67cKSSFhsV'],
          type: 'vector',
        });
      }
    });

    new maptilersdk.Marker().setLngLat(coordinates).addTo(map.current);
  }, [coordinates, isMounted]);

  return (
    <div className={styles.listingDetailMap}>
      <div className={styles.listingDetailMap} ref={mapContainer} />
    </div>
  );
}
